import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import { WorkTimeState } from '@/types/Component';

@Component({
    components: { Modal }
})
export default class SelectInterval extends Vue {
    // このコンポーネントでは、モーダルを開き直した際にコンポーネントの状態を維持することを仕様とする。

    @Prop()
    private value!: boolean;

    @Prop({
        required: false
    })
    private targetState?: WorkTimeState

    @Emit('input')
    private input(value: boolean) {
        value
    }

    @Emit('selectedTime')
    private selectedTime() {
        return {
            startWorktime: null,
            endWorktime: null,
            restTime: null,
            workTime: this.workHour + this.workMinute
        }
    }

    private workHour = 0
    private workMinute = 0

    private minutes = [
        {value: 0, display: '0分'},
        {value: 5, display: '5分'},
        {value: 10, display: '10分'},
        {value: 15, display: '15分'},
        {value: 20, display: '20分'},
        {value: 25, display: '25分'},
        {value: 30, display: '30分'},
        {value: 35, display: '35分'},
        {value: 40, display: '40分'},
        {value: 45, display: '45分'},
        {value: 50, display: '50分'},
        {value: 55, display: '55分'},
    ]

    private hours = [
        {value: 0, display: '0時間'},
        {value: 60, display: '1時間'},
        {value: 120, display: '2時間'},
        {value: 180, display: '3時間'},
        {value: 240, display: '4時間'},
        {value: 300, display: '5時間'},
        {value: 360, display: '6時間'},
        {value: 420, display: '7時間'},
        {value: 480, display: '8時間'},
        {value: 540, display: '9時間'},
        {value: 600, display: '10時間'},
        {value: 660, display: '11時間'},
        {value: 720, display: '12時間'},
        {value: 780, display: '13時間'},
        {value: 840, display: '14時間'},
        {value: 900, display: '15時間'},
        {value: 960, display: '16時間'},
        {value: 1020, display: '17時間'},
        {value: 1080, display: '18時間'},
        {value: 1140, display: '19時間'},
        {value: 1200, display: '20時間'},
        {value: 1260, display: '21時間'},
        {value: 1320, display: '22時間'},
        {value: 1380, display: '23時間'},
    ]

    @Watch('value')
    private openModal() {
        if(this.targetState?.workTime) {
            this.workHour = Math.floor(this.targetState.workTime / 60) * 60
            this.workMinute = this.targetState.workTime % 60
        }
    }

    get isModalVisible(): boolean {
        return this.value;
    }

    set isModalVisible(value: boolean) {
        this.input(value);
    }
}
